define('app/models/minicart_item',['app/setup'], function(takhfifan) {

  takhfifan.MinicartItem = Backbone.Model.extend({

    remove: function() {
      var _this = this;
      this.trigger('destroy', _this);

      $.post(this.get('deleteUrl'), {form_key: this.get('formKey')}, function(response) {
        if (response['success'] == 1) {
          var productDetails = {
            quantity : _this.get('quantity') || 0,
            id: _this.get('id'),
            name: _this.get('name'),
            price: _this.get('price'),
            brand: _this.get('vendorName'),
            category: _this.get('category')
          };
          takhfifan.eventHub.trigger('ga:removeFromCart',productDetails);
        } else {}
      });
    }

  });

});

